import { StyleSheet, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { StackHeaderProps } from '@react-navigation/stack';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { ParamListBase } from '@react-navigation/native';

import { colors, spacing } from '../../theme';
import { Text } from '../Text';
import { HeaderBackground } from './HeaderBackground';

export const Header = ({
	options: {
		headerLeft,
		headerTitle,
		headerBackTitle,
		headerRight,
		headerTintColor,
		title: fallbackTitle,
		headerTitleAlign,
	},
	navigation,
}: Props) => {
	const isSimpleTitle = typeof headerTitle === 'string';
	const left = headerLeft?.({
		canGoBack: navigation?.canGoBack(),
		label: headerBackTitle,
		tintColor: headerTintColor,
	});
	const title = headerTitle ? (
		isSimpleTitle ? (
			<Text numberOfLines={1} category="h3" align={headerTitleAlign}>
				{headerTitle}
			</Text>
		) : (
			headerTitle?.({
				children: fallbackTitle || '',
				tintColor: headerTintColor,
				style: styles.marginLeft,
			})
		)
	) : null;

	const right = headerRight?.({ tintColor: headerTintColor });

	return (
		<SafeAreaView style={styles.root} edges={['top']}>
			<View style={styles.header}>
				<HeaderBackground style={headerBackgroundStyle} />

				<View
					style={[
						styles.left,
						!headerLeft ? styles.marginLeft : undefined,
						headerTitleAlign === 'center' ? styles.flex1 : undefined,
					]}
				>
					{left}
					{isSimpleTitle && headerTitleAlign !== 'center' && title}
				</View>

				{(!isSimpleTitle || headerTitleAlign === 'center') && (
					<View style={styles.center}>{title}</View>
				)}

				{right && <View style={styles.right}>{right}</View>}
			</View>
		</SafeAreaView>
	);
};

type Props = Omit<StackHeaderProps, 'navigation'> & {
	navigation: NativeStackNavigationProp<ParamListBase, string>;
};

const headerBackgroundStyle = {
	position: 'absolute',
	top: 0,
	left: 0,
} as const;
const styles = StyleSheet.create({
	root: {
		backgroundColor: colors.background200,
		zIndex: 100,
	},
	header: {
		paddingVertical: spacing(2),
		paddingRight: spacing(2),
		paddingLeft: 0,
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'center',
		position: 'relative',
		height: 60,
	},
	left: {
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center',
	},
	center: {
		flex: 2,
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'center',
	},
	marginLeft: {
		marginLeft: spacing(2),
	},
	right: {
		flex: 1,
		flexDirection: 'row',
		justifyContent: 'flex-end',
		alignItems: 'center',
	},
	flex1: {
		flex: 1,
	},
});
